import'./pose-screen.scss'

/**
 *  Component Definition
 *
 * @export
 * @class PoseScreen
 * @implements {ng.IComponentOptions}
 */
export class PoseScreen implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: Function = PoseScreenController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./pose-screen.html').toString()

  /**
   * Object containing pairs Directive Bindings for Component
   *
   * @type {Object}
   */
  public bindings: { [binding: string]: string; } = {
    options: '=',
    isLast: '@',
    isFirst: '@',
  }
}

/**
 * PoseScreen - Controller
 *
 * @export
 * @class PoseScreenController
 */
export class PoseScreenController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', '$window', 'AngularServices', 'AppServices', '$element', '$animate', 'ProgressManager', 'TrackingManager']
  public options
  public isLast
  public isFirst
  public poseWidth: number;
  public poseHeight: number;
  public activeClicked;
  public navReady
  public disabledCarousel: boolean = true
  public carousel: any
  public slides: any
  public buttonNext: any
  public buttonPrev: any
  public currentSlide: any = 1;

  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public $window: any, public AngularServices: any, public AppServices: any, public $element: any, public $animate: any, public ProgressManager: any, public TrackingManager: any) {
    this.$log = $log.getInstance('PoseScreen', false);
    this.$log.debug('constructor')
  }

  // public calculatePoseDimensions(): void {
  //   let numPoses = this.options.carousel.items.length
  //   if (numPoses > 3) {
  //     this.poseWidth = 30;
  //     this.poseHeight = 50;
  //   } else {
  //     let numPoses = this.options.carousel.items.length
  //     let width = (100 / numPoses) - 3;
  //     this.poseHeight = 100;
  //     this.poseWidth = width;
  //   }
  // }

  public onNext() {
    this.AppServices.ScreenManager.performNavigation('next', this.options)
  }

  public onPrevious() {
    this.AppServices.ScreenManager.performNavigation('previous', this.options)
  }

  public onEnterStart() {
    this.$log.debug('onEnterStart');
    this.goToSlide(1)
  }
  public onEnterComplete() {
    this.$log.debug('onEnterComplete');
  }

  public onExitStart() {
    this.$log.debug("onExitStart")
    this.options.navReady = false
  }

  public onExitComplete() {
    this.$log.debug("onExitComplete")
    /*if (!this.TrackingManager.poseIsSet && this.TrackingManager.heroPose !== this.ProgressManager.getPose()){
      this.TrackingManager.trackPose(this.ProgressManager.getPose())
      this.TrackingManager.heroPose = this.ProgressManager.getPose()
    }*/
  }

  /**
   * life cycle hooks (road to ng2)
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit() {
    this.$log.debug('onInit', this.AppServices)

    //recalculate carousel size when a device switches orientation
    angular.element(this.$window).bind('orientationchange', this.poseCarouselSize);

    this.options.isLast = this.isLast;
    this.options.isFirst = this.isFirst;
    this.options.$element = this.$element;
    this.options.$ctrl = this;
    this.activeClicked = false;
    this.AppServices.ScreenManager.poseScreenOptions = this.options

    //this.AppServices.$strGenderScreen.setPoseGender(this.AppServices.HeroManager.selectedGender.toLowerCase());
    if(this.AppServices.HeroManager.selectedGender.toLowerCase()== 'male'){
       this.options.carousel = this.AppServices.CarouselManager.add(this.AppServices.DataManager.config.carousels.filter((value, index, array) => { return value.key === 'poses-male' })[0])
    }else{
      this.options.carousel = this.AppServices.CarouselManager.add(this.AppServices.DataManager.config.carousels.filter((value, index, array) => { return value.key === 'poses-female' })[0])
    }
    // custom carousel for pose selector

    this.carousel = document.getElementById('slides');
    this.slides = document.getElementsByClassName('slide');
    this.buttonNext = document.getElementById('buttonNext');
    this.buttonPrev = document.getElementById('buttonPrev');
    this.currentSlide = 1;

    // timeout to be sure the carousel is populated with slides
    this.AngularServices.$timeout(() => {
      this.poseCarouselSize();
      //this.AppServices.HeroManager.setPose(this.options.carousel.items[currentSlide].poseName);
      this.activeClicked = true;
    }, 1000);
  }


  public nextSlide(){
    this.activeClicked = false;
    this.goToSlide(this.currentSlide+1);
    if (this.options.carousel.items[this.currentSlide].enabled === true) {
      this.AppServices.HeroManager.setPose(this.options.carousel.items[this.currentSlide].poseName);
    }
  }

  public prevSlide(){
    this.activeClicked = false;
    this.goToSlide(this.currentSlide-1);
    if (this.options.carousel.items[this.currentSlide].enabled === true) {
      this.AppServices.HeroManager.setPose(this.options.carousel.items[this.currentSlide].poseName);
    }
  }

  public goToSlide(n){
    this.$animate.removeClass(this.slides[this.currentSlide], 'active');
    this.currentSlide = (n+3)%3;
    this.$animate.addClass(this.slides[this.currentSlide], 'active');
    this.poseCarouselSize();
    if (this.options.carousel.items[this.currentSlide].enabled === true) {
      this.AngularServices.$timeout(() => {
        this.activeClicked = true;
        this.options.nextDisabled = false;
      }, 600);
    } else {
      this.activeClicked = false;
      this.options.nextDisabled = true;
    }
  }

  // size function to handle dynamic sizes for each slide and carousel
  public poseCarouselSize(){
    //will need to add more cases here when we get more poses
    switch (this.currentSlide) {
      case 0:
        this.carousel.style.left = 0 - (document.querySelector('.screen-container').clientWidth/3) / 2.+ 'px'
        break;
      case 1:
        this.carousel.style.left = -document.querySelector('.screen-container').clientWidth * 0.5 + 'px'
        break;
      case 2:
        this.carousel.style.left = -document.querySelector('.screen-container').clientWidth * 1 + (document.querySelector('.screen-container').clientWidth/3) / 2 + 'px'
        break;
      default: break;
    }

    // carousel.style.left = - currentSlide * (w/slides.length)+ 'px';
    this.carousel.style.width = document.querySelector('.screen-container').clientWidth * 1.5 + 'px'
    for(let i=0; i < this.slides.length; i++){
      // make all slides 50% of game width
      this.slides[i].style.width = document.querySelector('.screen-container').clientWidth/3+ 'px'
    }
  }


  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges', changesObj)
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/pose-screen/pose-screen.ts
 **/